import React from 'react';
import '@sunrun/component-library/dist/fonts.css';
import { Global, css } from '@emotion/core';
import { Color } from '@sunrun/mui-theme';

export default () => (
  <Global
    styles={css`
      html {
        height: 100%;
      }

      body {
        height: 100%;
        margin: 0;
        font-family: Roobert, sans-serif;
        font-weight: 300;
      }

      #root {
        height: 100%;
      }

      p {
        color: ${Color.BLACK_85};
      }
    `}
  />
);
